<div class="sm:overflow-hidden hero-images mobi-ui-grid is-centered xsMax:full-bleed">
  @for (image of headerImages() | slice: 0 : 5; let i = $index; track image?.uuid ?? i) {
    <div
      class="hero-image mobi-ui-col-1/1 sm:mobi-ui-col-1/3 lg:!w-[20%] lg:!basis-[20%] mobi-ui-padding-t-xxl"
      [class]="{
        'hero-image-two': headerImages()?.length === 2,
        'mobi-ui-padding-b-lg': !!superTitle(),
        'mobi-ui-padding-b-sm': !superTitle(),
      }"
    >
      <div class="hero-image-animation-wrapper">
        <mobi-media
          [animation]="false"
          class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-400"
          [entity]="image"
          responsiveStyle="hero_five"
          rounded="full"
          [lazy]="i === 1 && (lead() || '').length <= 256 ? false : true"
        />
      </div>
    </div>
  }
</div>
<mobi-hero-text
  class="block w-full"
  [superTitle]="superTitle()"
  [subtitle]="subtitle()"
  [title]="title()"
  [lead]="lead()"
  [contentLinks]="contentLinks()"
  [primaryCta]="primaryCta() | extractUrl"
  [primaryCtaTarget]="primaryCta()?.options?.attributes?.target"
  [primaryCtaIcon]="primaryCtaIcon()"
  [secondaryCta]="secondaryCta() | extractUrl"
  [secondaryCtaIcon]="secondaryCtaIcon()"
  [secondaryCtaTarget]="secondaryCta()?.options?.attributes?.target"
  [primaryCtaTitle]="primaryCta()?.title"
  [secondaryCtaTitle]="secondaryCta()?.title"
></mobi-hero-text>
